import i18next, { type i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  directionOf,
  isSupportedLanguage,
  negotiateLanguage,
  panelResources,
  type SupportedLanguage,
} from '@iptv/localization';
import { readPref, writePref } from './storage.js';

const LANG_KEY = 'iptv.panel.lang';

function applyDocumentLanguage(lang: SupportedLanguage) {
  document.documentElement.lang = lang;
  document.documentElement.dir = directionOf(lang);
}

export function createPanelI18n(): i18n {
  const stored = readPref(LANG_KEY);
  const lang = isSupportedLanguage(stored)
    ? stored
    : negotiateLanguage(navigator.languages ?? [navigator.language], 'ar');
  const instance = i18next.createInstance();
  void instance.use(initReactI18next).init({
    resources: panelResources,
    lng: lang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    returnNull: false,
    showSupportNotice: false,
  });
  applyDocumentLanguage(lang);
  instance.on('languageChanged', (next) => {
    if (!isSupportedLanguage(next)) return;
    writePref(LANG_KEY, next);
    applyDocumentLanguage(next);
  });
  return instance;
}

export function currentLanguage(instance: i18n): SupportedLanguage {
  return isSupportedLanguage(instance.language) ? instance.language : 'en';
}
